import { GridBlockType } from 'services/entities/BlockTypes';

export type PageOrientation = 'portrait' | 'landscape';

export type PageSize = {
  label: string;
  width: number;
  height: number;
};

export const PAGE_SIZE_PORTRAIT_A4: PageSize = { label: 'document.page.size.a4', width: 794, height: 1123 };
export const PAGE_SIZE_PORTRAIT_LEGAL: PageSize = { label: 'document.page.size.legal', width: 816, height: 1344 };
export const PAGE_SIZE_US_PORTRAIT_LETTER: PageSize = { label: 'document.page.size.us_letter', width: 816, height: 1056 };

export const PAGE_SIZES: readonly PageSize[] = [PAGE_SIZE_PORTRAIT_A4, PAGE_SIZE_PORTRAIT_LEGAL, PAGE_SIZE_US_PORTRAIT_LETTER];
export const DEFAULT_PAGE_SIZE = PAGE_SIZE_US_PORTRAIT_LETTER;

export const gridPixelSize = 1;
export const gridPageMaxWidthInPixels = 816;
export const gridPageMinHeightInPixels = 1056;
export const gridDefaultPixelDensity = 96;
export const gridDefaultWidth = 712;
export const gridDefaultWidthInInches = 8.5;
export const gridDefaultHeight = 24;
export const gridDefaultHeightInInches = 11;
export const gridDefaultXAxis = 50;
export const gridDefaultYAxis = 66;
export const gridDefaultGreaterZAxis = 0;
export const gridSnapDistanceInPx = 2;
export const gridDragLinePreviewDistanceInPx = 8;

export const gridDefaultDimensionsOnDrop = {
  [GridBlockType.TEXT]: {
    width: 250,
    height: 250,
  },
  [GridBlockType.TABLE]: {
    width: 666,
    height: 158,
  },
  [GridBlockType.VIDEO]: {
    width: 500,
    height: 281, // 16:9 aspect ratio
  },
  [GridBlockType.SHAPE]: {
    width: 200,
    height: 200,
  },
  [GridBlockType.IMAGE]: {
    width: 320,
    height: 320,
  },
  [GridBlockType.EMBED]: {
    width: 744,
    height: 392,
  },
};
export const gridDefaultDimensionsOnTablePricing = {
  width: 721,
  height: 470,
};

// Accepts undefined so callers can pass documentSettings.pageOrientation directly
// without a null-check; undefined is treated as portrait (the safe default).
export function getCanvasWidth(orientation: PageOrientation | undefined): number {
  return orientation === 'landscape' ? gridPageMinHeightInPixels : gridPageMaxWidthInPixels;
}

export function getCanvasMinHeight(orientation: PageOrientation | undefined): number {
  return orientation === 'landscape' ? gridPageMaxWidthInPixels : gridPageMinHeightInPixels;
}
